import { Server } from 'lucide-react'
import { CSSProperties, FC } from 'react'

type CoverProps = {
  src?: string
  color?: string
  iconColor?: string
  overlayColor?: string
}

const Image = ({ src }: Pick<CoverProps, 'src'>) =>
  src ? (
    <img className="w-full" src={src} alt="cover" />
  ) : (
    <div className="h-[200px] w-full" />
  )

const Icon = ({
  color,
  iconColor,
  overlayColor,
}: Pick<CoverProps, 'color' | 'iconColor' | 'overlayColor'>) => (
  <div
    data-testid="branding-logo"
    className="absolute left-1/2 top-full -translate-x-1/2 -translate-y-1/2 rounded-full p-l shadow-md"
    style={
      {
        background: `linear-gradient(0deg, ${overlayColor} 0%, ${overlayColor} 100%), ${color}`,
      } as CSSProperties
    }
  >
    <Server size={48} className={iconColor} />
  </div>
)

export const Cover: FC<CoverProps> = ({
  src,
  color,
  iconColor,
  overlayColor,
}) => {
  return (
    <div data-testid="branding-cover" className="relative mb-12">
      <Image src={src} />
      <Icon color={color} iconColor={iconColor} overlayColor={overlayColor} />
    </div>
  )
}
